// extracted by mini-css-extract-plugin
module.exports = {"fbBtnLogin":"FacebookLoginButton-module__fbBtnLogin___37PMu","fbBtnLogout":"FacebookLoginButton-module__fbBtnLogout___1lbsL","fbText":"FacebookLoginButton-module__fbText___2Cb3w"};